export default __webpack_public_path__ + "static/media/geology-mars.d3ffce8e.png";